<template>
  <div>
    <b-row>
      <b-col md="12">
        <div
          class="d-flex"
          v-if="
            !hasRecibo &&
              (USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TESORERIA)
          "
        >
          <b-form-checkbox
            style="display: none;"
            v-model="checkAutomatico"
            name="check-button"
            switch
          >
            Automatico
          </b-form-checkbox>
          <div class="form-label-group ml-1" v-if="checkAutomatico">
            <b-form-input placeholder="Ingrese valor a cobrar" size="sm" />
            <label for="floating-label1">Valor a cobrar</label>
          </div>
        </div>
        <b-col
          md="12"
          class="d-flex justify-content-center"
          style="background-color:#adadad; color:white; font-size:13px; padding:5px; border-radius:3px"
        >
          <div><b>Multas Pendientes</b></div>
        </b-col>
        <!-- <b-col md="12">Recibo #: {{ dataRecibo.numRecibo }}</b-col>
      <b-col md="12">Fecha emisión: {{ dataRecibo.fechaEmision }}</b-col> -->
        <b-overlay
          :show="loading"
          :style="loading ? 'margin-top:40px' : 'margin-top:0px'"
        >
          <b-list-group style="overflow: auto; max-height: 60vh;">
            <template v-for="item in listMultasRecibo">
              <div
                :key="item.idAux"
                style="font-size: 12px; padding: 5px; border-top: 1px solid gray;"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div style="width: 80%;">
                    <span>{{ item.concepto }}</span>
                  </div>
                  <small
                    style="width: 12%; text-align: right; font-size: 16px;"
                    class="text-secondary"
                  >
                    <b>{{ item.v_total }}</b>
                    <span style="font-size: 15px; color: rgb(210, 208, 207);"
                      >$</span
                    >
                  </small>
                  <b-button
                    v-if="
                      bloquearRecibo != 's' &&
                        !hasRecibo &
                          (USER().rol === ROLES.SUPER ||
                            USER().rol === ROLES.ADMIN ||
                            USER().rol === ROLES.TESORERIA)
                    "
                    @click="enviarDetalle(item)"
                    variant="flat-success"
                    class="btn-icon"
                    size="sm"
                  >
                    <feather-icon size="14" icon="ArrowRightIcon" />
                  </b-button>
                </div>
                <span style="color:rgb(183, 181, 181);font-size: 10px;"
                  >campeonato {{ item.campeonato }}</span
                >
              </div>
            </template>
          </b-list-group>
          <div style="background: #eaeaea;padding: 10px;font-weight: bolder">
            TOTAL DEUDA <span style="float:right">{{ totalPendiente }}<span>$</span></span>
          </div>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BFormCheckbox,
  BFormInput,
  BRow,
  BCol,
  BListGroup,
  // BListGroupItem,
  BButton,
  BOverlay,
  //    xxx
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import {
  // URL,
  USER,
  ROLES,
  // xxx,
} from '../../utils/variables'

export default {
  components: {
    BFormCheckbox,
    BFormInput,
    BRow,
    BCol,
    BListGroup,
    // BListGroupItem,
    BButton,
    BOverlay,
  },
  props: {
    listMultasRecibo: Array,
    bloquearRecibo: String,
    hasRecibo: Boolean,
    loading: Boolean,
    totalPendiente: String,
  },
  setup(props, { emit }) {
    const checkAutomatico = ref(false)
    function quitarArray(item) {
      const found = props.listMultasRecibo.findIndex(
        // eslint-disable-next-line
        element => element.idAux === item.idAux
      )
      // console.log(found)
      props.listMultasRecibo.splice(found, 1)
    }
    function enviarDetalle(item) {
      // console.log(item)
      emit('ponerEnDetalle', item)
      quitarArray(item)
    }

    return {
      enviarDetalle,
      checkAutomatico,
      USER,
      ROLES,
    }
  },
}
</script>
